var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#565656"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4022 10.5035C27.1404 9.51804 26.3694 8.74196 25.3903 8.47858C23.6157 8 16.4999 8 16.4999 8C16.4999 8 9.38403 8 7.6094 8.47858C6.63036 8.742 5.85928 9.51804 5.59757 10.5035C5.12207 12.2896 5.12207 16.0162 5.12207 16.0162C5.12207 16.0162 5.12207 19.7427 5.59757 21.5289C5.85928 22.5143 6.63036 23.258 7.6094 23.5214C9.38403 24 16.4999 24 16.4999 24C16.4999 24 23.6157 24 25.3903 23.5214C26.3694 23.258 27.1404 22.5143 27.4022 21.5289C27.8777 19.7427 27.8777 16.0162 27.8777 16.0162C27.8777 16.0162 27.8777 12.2896 27.4022 10.5035ZM14.1726 19.3996V12.6327L20.12 16.0162L14.1726 19.3996Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.79e7d0785c7a896608a14446e181275b.svg";
export { ForwardRef as ReactComponent };